import React from "react";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const AccordionSection = ({
  title,
  isExpanded,
  toggleExpand,
  children,
  icon,
  transitionStyle = {},
}) => {
  return (
    <div className="mb-4 sm:mb-5 border border-gray-200 rounded-lg overflow-visible shadow-sm">
      <div
        className="flex justify-between items-center p-4 sm:p-5 bg-gray-50 cursor-pointer hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 touch-manipulation min-h-[56px]"
        onClick={(e) => toggleExpand(e)}
      >
        <div className="flex items-center">
          {icon && (
            <span className="mr-2 sm:mr-3 text-lg sm:text-base">{icon}</span>
          )}
          <h3 className="font-medium text-gray-800 text-base sm:text-lg">
            {title}
          </h3>
        </div>
        <div className="flex-shrink-0 ml-2">
          {isExpanded ? (
            <FiChevronUp className="text-gray-500 w-5 h-5 sm:w-4 sm:h-4" />
          ) : (
            <FiChevronDown className="text-gray-500 w-5 h-5 sm:w-4 sm:h-4" />
          )}
        </div>
      </div>
      <div
        className={`transition-all duration-300 ${
          isExpanded
            ? "max-h-[2000px] opacity-100"
            : "max-h-0 opacity-0 overflow-hidden"
        }`}
        style={{
          position: "relative",
          ...transitionStyle,
        }}
      >
        <div className="p-4 sm:p-5 border-t border-gray-200">{children}</div>
      </div>
    </div>
  );
};

export default AccordionSection;
